import React from 'react'
import ClipLoader from "react-spinners/ClipLoader";


const LoadingPage = (props) => {

    const override = {
        display: "flex",
        borderWidth: '5px',
        height: '50px',
        width: '50px',
    };

  return (
    <div className='page_loading' style={{height:props.height}}>
      <ClipLoader
        color={'#001e00'}
        loading={true}
        cssOverride={override}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>  
  )
}

export default LoadingPage